export class RangosIngresoModel {
  
    id: string;  
    nse: string;  
    avg: string;        
}



